import React from 'react';

import SearchPreview from '../../../../components/SearchPreview';
import SearchPreviewSkeleton from '../../../../components/SearchPreview/SearchPreviewSkeleton';
import useFetchListings from '../../../../hooks/useFetchListings';
import trackEvent from '../../../../utils/trackEvent';
import { TSearchRequest } from '../../../../types/TConfigurablePage';
import EmptyStateCard from '../../../../components/EmptyStateCard';

type TProps = {
  searchRequest: TSearchRequest;
  title: string;
  lrpUrl: string;
  ctaText?: string;
  showNumberOfAds?: boolean;
};

const handlePreviewListingClick = (title) => {
  trackEvent({ eventAction: 'ClickSearchPreviewListing', eventLabel: title });
};

const handleCtaClick = (title) => {
  trackEvent({ eventAction: 'ClickSearchPreviewCta', eventLabel: title });
};

const SearchPreviewBase = ({ searchRequest = {}, showNumberOfAds, lrpUrl, title, ctaText }: TProps) => {
  const modifiedSearchRequest = {
    ...searchRequest,
    limit: 4,
    sorting: {
      sortBy: searchRequest.sorting?.sortBy || 'SORT_INDEX',
      sortOrder: searchRequest.sorting?.sortOrder || 'DECREASING',
    },
  };
  const { listings, totalCount, isLoading, isError } = useFetchListings({ searchRequest: modifiedSearchRequest });

  if (isLoading) {
    return <SearchPreviewSkeleton />;
  }

  if (isError) {
    return <EmptyStateCard message="shared.emptyStateText" />;
  }

  return (
    <SearchPreview
      listings={listings}
      listingsCount={showNumberOfAds ? totalCount : null}
      title={title}
      categoryId={searchRequest.l1CategoryId}
      ctaUrl={lrpUrl}
      ctaText={ctaText}
      onClickPreviewListing={() => handlePreviewListingClick(title)}
      onClickCta={() => handleCtaClick(title)}
    />
  );
};

export default SearchPreviewBase;
